export var AccountHasFilter;
(function (AccountHasFilter) {
    AccountHasFilter["Email"] = "email";
    AccountHasFilter["FirstName"] = "firstName";
    AccountHasFilter["LastName"] = "lastName";
    AccountHasFilter["Organisation"] = "organisation";
    AccountHasFilter["Phone"] = "phone";
    AccountHasFilter["Preferences"] = "preferences";
    AccountHasFilter["Role"] = "role";
})(AccountHasFilter || (AccountHasFilter = {}));
export var AccountOrderable;
(function (AccountOrderable) {
    AccountOrderable["Email"] = "email";
    AccountOrderable["FirstName"] = "firstName";
    AccountOrderable["LastName"] = "lastName";
    AccountOrderable["Phone"] = "phone";
    AccountOrderable["Preferences"] = "preferences";
})(AccountOrderable || (AccountOrderable = {}));
export var AggregatedMetricsHasFilter;
(function (AggregatedMetricsHasFilter) {
    AggregatedMetricsHasFilter["Avg"] = "avg";
    AggregatedMetricsHasFilter["Count"] = "count";
    AggregatedMetricsHasFilter["Max"] = "max";
    AggregatedMetricsHasFilter["Min"] = "min";
    AggregatedMetricsHasFilter["Name"] = "name";
    AggregatedMetricsHasFilter["Sum"] = "sum";
})(AggregatedMetricsHasFilter || (AggregatedMetricsHasFilter = {}));
export var AggregatedMetricsOrderable;
(function (AggregatedMetricsOrderable) {
    AggregatedMetricsOrderable["Avg"] = "avg";
    AggregatedMetricsOrderable["Count"] = "count";
    AggregatedMetricsOrderable["Max"] = "max";
    AggregatedMetricsOrderable["Min"] = "min";
    AggregatedMetricsOrderable["Name"] = "name";
    AggregatedMetricsOrderable["Sum"] = "sum";
})(AggregatedMetricsOrderable || (AggregatedMetricsOrderable = {}));
/** CoordinateSystem represents the coordinate system. */
export var CoordinateSystem;
(function (CoordinateSystem) {
    /** Local coordinates (1.0 = 1km) */
    CoordinateSystem["CoordLocal"] = "COORD_LOCAL";
    /** WGS84 (GPS) coordinates */
    CoordinateSystem["CoordWgs84"] = "COORD_WGS84";
})(CoordinateSystem || (CoordinateSystem = {}));
export var DgraphIndex;
(function (DgraphIndex) {
    DgraphIndex["Bool"] = "bool";
    DgraphIndex["Day"] = "day";
    DgraphIndex["Exact"] = "exact";
    DgraphIndex["Float"] = "float";
    DgraphIndex["Fulltext"] = "fulltext";
    DgraphIndex["Geo"] = "geo";
    DgraphIndex["Hash"] = "hash";
    DgraphIndex["Hnsw"] = "hnsw";
    DgraphIndex["Hour"] = "hour";
    DgraphIndex["Int"] = "int";
    DgraphIndex["Int64"] = "int64";
    DgraphIndex["Month"] = "month";
    DgraphIndex["Regexp"] = "regexp";
    DgraphIndex["Term"] = "term";
    DgraphIndex["Trigram"] = "trigram";
    DgraphIndex["Year"] = "year";
})(DgraphIndex || (DgraphIndex = {}));
export var EventHasFilter;
(function (EventHasFilter) {
    EventHasFilter["Description"] = "description";
    EventHasFilter["End"] = "end";
    EventHasFilter["Entity"] = "entity";
    EventHasFilter["Name"] = "name";
    EventHasFilter["Start"] = "start";
    EventHasFilter["Type"] = "type";
})(EventHasFilter || (EventHasFilter = {}));
export var EventOrderable;
(function (EventOrderable) {
    EventOrderable["Description"] = "description";
    EventOrderable["End"] = "end";
    EventOrderable["Name"] = "name";
    EventOrderable["Start"] = "start";
    EventOrderable["Type"] = "type";
})(EventOrderable || (EventOrderable = {}));
export var GeoTypeHasFilter;
(function (GeoTypeHasFilter) {
    GeoTypeHasFilter["Description"] = "description";
    GeoTypeHasFilter["DisplayName"] = "displayName";
    GeoTypeHasFilter["Entities"] = "entities";
    GeoTypeHasFilter["Name"] = "name";
})(GeoTypeHasFilter || (GeoTypeHasFilter = {}));
export var GeoTypeOrderable;
(function (GeoTypeOrderable) {
    GeoTypeOrderable["Description"] = "description";
    GeoTypeOrderable["DisplayName"] = "displayName";
    GeoTypeOrderable["Name"] = "name";
})(GeoTypeOrderable || (GeoTypeOrderable = {}));
export var HttpMethod;
(function (HttpMethod) {
    HttpMethod["Delete"] = "DELETE";
    HttpMethod["Get"] = "GET";
    HttpMethod["Patch"] = "PATCH";
    HttpMethod["Post"] = "POST";
    HttpMethod["Put"] = "PUT";
})(HttpMethod || (HttpMethod = {}));
/** MetricDataType represents the scalar type of a metric. */
export var MetricDataType;
(function (MetricDataType) {
    /** Boolean value */
    MetricDataType["Bool"] = "BOOL";
    /** Floating point value */
    MetricDataType["Float"] = "FLOAT";
    /** Integer value */
    MetricDataType["Int"] = "INT";
    /** String value */
    MetricDataType["String"] = "STRING";
    /** Timestamp value */
    MetricDataType["Timestamp"] = "TIMESTAMP";
})(MetricDataType || (MetricDataType = {}));
export var MetricHasFilter;
(function (MetricHasFilter) {
    MetricHasFilter["DataType"] = "dataType";
    MetricHasFilter["Description"] = "description";
    MetricHasFilter["Group"] = "group";
    MetricHasFilter["Measures"] = "measures";
    MetricHasFilter["Name"] = "name";
    MetricHasFilter["Unit"] = "unit";
})(MetricHasFilter || (MetricHasFilter = {}));
export var MetricOrderable;
(function (MetricOrderable) {
    MetricOrderable["Description"] = "description";
    MetricOrderable["Name"] = "name";
    MetricOrderable["Unit"] = "unit";
})(MetricOrderable || (MetricOrderable = {}));
export var MetricTypeHasFilter;
(function (MetricTypeHasFilter) {
    MetricTypeHasFilter["Description"] = "description";
    MetricTypeHasFilter["Metrics"] = "metrics";
    MetricTypeHasFilter["Name"] = "name";
})(MetricTypeHasFilter || (MetricTypeHasFilter = {}));
export var MetricTypeOrderable;
(function (MetricTypeOrderable) {
    MetricTypeOrderable["Description"] = "description";
    MetricTypeOrderable["Name"] = "name";
})(MetricTypeOrderable || (MetricTypeOrderable = {}));
export var MetricValueHasFilter;
(function (MetricValueHasFilter) {
    MetricValueHasFilter["Entity"] = "entity";
    MetricValueHasFilter["EntityId"] = "entityID";
    MetricValueHasFilter["EntityIDmetricId"] = "entityIDmetricID";
    MetricValueHasFilter["Metric"] = "metric";
    MetricValueHasFilter["MetricId"] = "metricID";
    MetricValueHasFilter["Sensor"] = "sensor";
    MetricValueHasFilter["SensorId"] = "sensorID";
    MetricValueHasFilter["Timestamp"] = "timestamp";
    MetricValueHasFilter["Value"] = "value";
})(MetricValueHasFilter || (MetricValueHasFilter = {}));
export var MetricValueOrderable;
(function (MetricValueOrderable) {
    MetricValueOrderable["EntityId"] = "entityID";
    MetricValueOrderable["EntityIDmetricId"] = "entityIDmetricID";
    MetricValueOrderable["MetricId"] = "metricID";
    MetricValueOrderable["SensorId"] = "sensorID";
    MetricValueOrderable["Timestamp"] = "timestamp";
    MetricValueOrderable["Value"] = "value";
})(MetricValueOrderable || (MetricValueOrderable = {}));
export var Mode;
(function (Mode) {
    Mode["Batch"] = "BATCH";
    Mode["Single"] = "SINGLE";
})(Mode || (Mode = {}));
export var OrganisationHasFilter;
(function (OrganisationHasFilter) {
    OrganisationHasFilter["Accounts"] = "accounts";
    OrganisationHasFilter["Addresses"] = "addresses";
    OrganisationHasFilter["BId"] = "bID";
    OrganisationHasFilter["Country"] = "country";
    OrganisationHasFilter["CountryIso3"] = "countryISO3";
    OrganisationHasFilter["Entities"] = "entities";
    OrganisationHasFilter["Locality"] = "locality";
    OrganisationHasFilter["Logo"] = "logo";
    OrganisationHasFilter["Name"] = "name";
    OrganisationHasFilter["Phone"] = "phone";
    OrganisationHasFilter["Postcode"] = "postcode";
    OrganisationHasFilter["Preferences"] = "preferences";
    OrganisationHasFilter["Region"] = "region";
    OrganisationHasFilter["Timezone"] = "timezone";
    OrganisationHasFilter["Website"] = "website";
})(OrganisationHasFilter || (OrganisationHasFilter = {}));
export var OrganisationOrderable;
(function (OrganisationOrderable) {
    OrganisationOrderable["BId"] = "bID";
    OrganisationOrderable["Country"] = "country";
    OrganisationOrderable["CountryIso3"] = "countryISO3";
    OrganisationOrderable["Locality"] = "locality";
    OrganisationOrderable["Logo"] = "logo";
    OrganisationOrderable["Name"] = "name";
    OrganisationOrderable["Phone"] = "phone";
    OrganisationOrderable["Postcode"] = "postcode";
    OrganisationOrderable["Preferences"] = "preferences";
    OrganisationOrderable["Region"] = "region";
    OrganisationOrderable["Timezone"] = "timezone";
    OrganisationOrderable["Website"] = "website";
})(OrganisationOrderable || (OrganisationOrderable = {}));
export var RoleHasFilter;
(function (RoleHasFilter) {
    RoleHasFilter["Accounts"] = "accounts";
    RoleHasFilter["Description"] = "description";
    RoleHasFilter["Name"] = "name";
})(RoleHasFilter || (RoleHasFilter = {}));
export var RoleOrderable;
(function (RoleOrderable) {
    RoleOrderable["Description"] = "description";
    RoleOrderable["Name"] = "name";
})(RoleOrderable || (RoleOrderable = {}));
export var SensorHasFilter;
(function (SensorHasFilter) {
    SensorHasFilter["BId"] = "bID";
    SensorHasFilter["Entity"] = "entity";
    SensorHasFilter["FirmwareVersion"] = "firmwareVersion";
    SensorHasFilter["Maker"] = "maker";
    SensorHasFilter["MakerId"] = "makerID";
    SensorHasFilter["Measures"] = "measures";
    SensorHasFilter["MetricType"] = "metricType";
    SensorHasFilter["ModelName"] = "modelName";
    SensorHasFilter["Name"] = "name";
    SensorHasFilter["Priority"] = "priority";
})(SensorHasFilter || (SensorHasFilter = {}));
export var SensorOrderable;
(function (SensorOrderable) {
    SensorOrderable["BId"] = "bID";
    SensorOrderable["FirmwareVersion"] = "firmwareVersion";
    SensorOrderable["Maker"] = "maker";
    SensorOrderable["MakerId"] = "makerID";
    SensorOrderable["ModelName"] = "modelName";
    SensorOrderable["Name"] = "name";
    SensorOrderable["Priority"] = "priority";
})(SensorOrderable || (SensorOrderable = {}));
export var TwinEntityHasFilter;
(function (TwinEntityHasFilter) {
    TwinEntityHasFilter["AggregateMetrics"] = "aggregateMetrics";
    TwinEntityHasFilter["AggregatedMetrics"] = "aggregatedMetrics";
    TwinEntityHasFilter["Altitude"] = "altitude";
    TwinEntityHasFilter["BId"] = "bID";
    TwinEntityHasFilter["Boundaries"] = "boundaries";
    TwinEntityHasFilter["Capacity"] = "capacity";
    TwinEntityHasFilter["Centre"] = "centre";
    TwinEntityHasFilter["Children"] = "children";
    TwinEntityHasFilter["CoordinateSystem"] = "coordinateSystem";
    TwinEntityHasFilter["Definitions"] = "definitions";
    TwinEntityHasFilter["Description"] = "description";
    TwinEntityHasFilter["Event"] = "event";
    TwinEntityHasFilter["FirmwareVersion"] = "firmwareVersion";
    TwinEntityHasFilter["GeoType"] = "geoType";
    TwinEntityHasFilter["Location"] = "location";
    TwinEntityHasFilter["Maker"] = "maker";
    TwinEntityHasFilter["MakerId"] = "makerID";
    TwinEntityHasFilter["MapCentre"] = "mapCentre";
    TwinEntityHasFilter["MapOrigin"] = "mapOrigin";
    TwinEntityHasFilter["Measures"] = "measures";
    TwinEntityHasFilter["ModelFile"] = "modelFile";
    TwinEntityHasFilter["ModelName"] = "modelName";
    TwinEntityHasFilter["Name"] = "name";
    TwinEntityHasFilter["NonFunctional"] = "nonFunctional";
    TwinEntityHasFilter["OpeningHours"] = "openingHours";
    TwinEntityHasFilter["Organisation"] = "organisation";
    TwinEntityHasFilter["Parent"] = "parent";
    TwinEntityHasFilter["Path"] = "path";
    TwinEntityHasFilter["RotationX"] = "rotationX";
    TwinEntityHasFilter["RotationY"] = "rotationY";
    TwinEntityHasFilter["RotationZ"] = "rotationZ";
    TwinEntityHasFilter["Sensors"] = "sensors";
    TwinEntityHasFilter["ShortName"] = "shortName";
    TwinEntityHasFilter["Tags"] = "tags";
    TwinEntityHasFilter["Tracked"] = "tracked";
    TwinEntityHasFilter["Type"] = "type";
})(TwinEntityHasFilter || (TwinEntityHasFilter = {}));
export var TwinEntityOrderable;
(function (TwinEntityOrderable) {
    TwinEntityOrderable["Altitude"] = "altitude";
    TwinEntityOrderable["BId"] = "bID";
    TwinEntityOrderable["Capacity"] = "capacity";
    TwinEntityOrderable["Definitions"] = "definitions";
    TwinEntityOrderable["Description"] = "description";
    TwinEntityOrderable["FirmwareVersion"] = "firmwareVersion";
    TwinEntityOrderable["Maker"] = "maker";
    TwinEntityOrderable["MakerId"] = "makerID";
    TwinEntityOrderable["ModelFile"] = "modelFile";
    TwinEntityOrderable["ModelName"] = "modelName";
    TwinEntityOrderable["Name"] = "name";
    TwinEntityOrderable["OpeningHours"] = "openingHours";
    TwinEntityOrderable["RotationX"] = "rotationX";
    TwinEntityOrderable["RotationY"] = "rotationY";
    TwinEntityOrderable["RotationZ"] = "rotationZ";
    TwinEntityOrderable["ShortName"] = "shortName";
})(TwinEntityOrderable || (TwinEntityOrderable = {}));
export var TwinEntityTypeHasFilter;
(function (TwinEntityTypeHasFilter) {
    TwinEntityTypeHasFilter["Description"] = "description";
    TwinEntityTypeHasFilter["DisplayName"] = "displayName";
    TwinEntityTypeHasFilter["Entities"] = "entities";
    TwinEntityTypeHasFilter["Name"] = "name";
})(TwinEntityTypeHasFilter || (TwinEntityTypeHasFilter = {}));
export var TwinEntityTypeOrderable;
(function (TwinEntityTypeOrderable) {
    TwinEntityTypeOrderable["Description"] = "description";
    TwinEntityTypeOrderable["DisplayName"] = "displayName";
    TwinEntityTypeOrderable["Name"] = "name";
})(TwinEntityTypeOrderable || (TwinEntityTypeOrderable = {}));
